module.exports = __webpack_public_path__ + "static/media/tech-video-2.d13837a0.png";